// Types
import { Selector } from 'react-redux';
import { EditorInstanceObject, TiptapEditorStoreState } from './tiptapEditorStoreTypes';

export const getActiveTiptapEditor: Selector<TiptapEditorStoreState, EditorInstanceObject | null> = (state) =>
    state.activeEditor;

/**
 * Returns the Tiptap editor instance for the supplied stable editor ID.
 */
export const getTiptapEditorById = (state: TiptapEditorStoreState, editorId: string): EditorInstanceObject | null =>
    state.editorsById[editorId] ?? null;
